import { render } from "./Glamping.vue?vue&type=template&id=313ab20e"
import script from "./Glamping.vue?vue&type=script&lang=js"
export * from "./Glamping.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__